import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { setupErrorHandler } from "./utils/errorHandler";

// Configurer le gestionnaire d'erreurs avant le rendu
setupErrorHandler();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
